import { Button, ButtonSize, ButtonTheme } from '@cian/button-component';
import * as React from 'react';

interface ISaveButtonProps {
  type?: 'submit' | 'button';
  isFetching: boolean;
}

export class SaveButton extends React.PureComponent<ISaveButtonProps, {}> {
  public render() {
    const { type = 'button', isFetching } = this.props;

    return (
      <div>
        <Button size={ButtonSize.S} theme={ButtonTheme.Ghost} type={type} isSync={isFetching}>
          Сохранить
        </Button>
      </div>
    );
  }
}
